import './SpecificationLabel.scss';

function SpecificationLabel({ data }) {
	return (
		<div className="vimdt-specification-label">
			<pre>{JSON.stringify(data, null, 2)}</pre>
		</div>
	);
}

export default SpecificationLabel;
